import "./photography.css";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { photographyMap } from "../../model/photography";
import { assetsMap, imageInitializer } from "../../model/assets.js";
import contactMeHere from "../../assets/contactMeHere.svg";
import content from "../../assets/content.svg";
import { Navigation } from '../home/navigation/navigation';
import { useEffect, useState } from "react";

const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}
const mainElements = Object.entries({
    bodyWater1: photographyMap.bodyWater1,
    bodyWater2: photographyMap.bodyWater2,
    bodyWater3: photographyMap.bodyWater3
});
const entries = Object.entries(photographyMap);
const elements = shuffleArray(entries);

const Photography = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const origin = urlParams.get("origin");
    const isPortfolio = urlParams.get("display") === "portfolio";
    const [assets, setAssets] = useState(assetsMap);
    useEffect(() => {
        let timeout = imageInitializer(setAssets);
        return () => {
            clearTimeout(timeout);
        }
    }, [assets]);
    return (
        assets.busy ?
        <div className="view fullscreen align-center" style={{background: "black"}}>
            <img height="300" alt="" src="./assets/loading.gif"/>
        </div>
        :
        <div className={`view photography ${isPortfolio ? "portfolio": "standalone"}`}>
            {
                isPortfolio ?
                <>
                    <Link to={"../collections"}><button className="reveal reveal-area action top left round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
                    <h2 className="view-title"><FormattedMessage id="photography"/></h2>
                </>
                :
                <>
                    <Navigation/>
                    <div className="action top left align-center">
                        <Link to={`../${origin || "home"}`}><button className="reveal reveal-area action round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
                        <Link to={"../portfolio"}><button className="reveal reveal-area round action align-center"><img draggable="false" alt="" width="30" height="30" src={ content }/><span className="optimizeSmall"><FormattedMessage id="titlePortfolio"/></span></button></Link>
                    </div>
                    <h2><FormattedMessage id="titlePhotography"/></h2>
                </>
            }
            <p className="intro"><FormattedMessage id="introPhotography" values={{rtn: <br/>}}/></p>
            <figure className="photo-container reveal-area">
                {mainElements.map((value, index) => <Link key={ index } to={ `../gallery/view?id=${value[0]}&origin=photography${isPortfolio ? "&display=portfolio" : ""}` }><button className="photo invisible reveal" style={{ animationDelay: (mainElements.length - index + 0.1) / (4 * mainElements.length) + "s", backgroundImage: `url(${ value[1].file })` }}/></Link>)}
                <figcaption>Collection <i>Body and Water</i> - ©️ Rémy Jeuniaux</figcaption>
            </figure>
            <section>
                <h3><FormattedMessage id="subtitle_photo1"/></h3>
                <p className="text"><FormattedMessage id="txt_photo1"/></p>
            </section>
            <section>
                <h3><FormattedMessage id="subtitle_photo2"/></h3>
                <p className="text"><FormattedMessage id="txt_photo2"/></p>
            </section>
            <div className="photoGrid">
                    <div style={{filter: "brightness(var(--brightness-gradient-20))", transitionDelay: "0s"}}></div>
                    <div style={{filter: "brightness(var(--brightness-gradient-50))", transitionDelay: "0.1s"}}></div>
                    <div style={{filter: "brightness(var(--brightness-gradient-80))", transitionDelay: "0.3s"}}></div>
            {elements.map((value, index) => <Link key={ index } to={ `../gallery/view?id=${value[0]}&origin=photography${isPortfolio ? "&display=portfolio" : ""}` }><button className="photo invisible" style={{ animationDelay: (elements.length - index + 0.1) / (4 * elements.length) + "s", backgroundImage: `url(${ value[1].file })` }}/></Link>)}

            <span className="contactMe themed">
                <img draggable="false" className="contactMeHere" width="85" alt="" src={contactMeHere} />
                <FormattedMessage id="contact_work"/><br/>
                <a href="mailto:remy.jeuniaux@icloud.com"><small><FormattedMessage id="contact_me"/></small></a>
            </span>
            </div>
        </div>
    );
}

export default Photography;